export default "__VITE_ASSET__kNW03X1M__"